(function () {
  'use strict';

  var DESKTOP_BP  = 834;
  var THRESHOLD   = 40;
  var COOLDOWN_MS = 420;

  function init() {
    var section = document.querySelector('customers-carousel');
    if (!section) return;
    var sliderEl = section.querySelector('.homepage-customers__slider');
    if (!sliderEl) return;

    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      var swiper = section.swiper;
      if (swiper) { clearInterval(poll); attach(sliderEl, swiper); }
      if (tries > 60) clearInterval(poll);
    }, 50);
  }

  function attach(el, swiper) {
    var accumulated = 0;
    var cooling     = false;
    var coolTimer   = null;
    var inside      = false;

    /* Detectar cuando el mouse entra/sale del slider */
    el.addEventListener('mouseenter', function () { inside = true;  });
    el.addEventListener('mouseleave', function () { inside = false; accumulated = 0; });

    /* Captura en la fase CAPTURE para interceptar antes del navegador.
       passive: false es obligatorio para poder llamar preventDefault. */
    document.addEventListener('wheel', function (e) {
      if (!inside) return;
      if (window.innerWidth <= DESKTOP_BP) return;

      var absX = Math.abs(e.deltaX);
      var absY = Math.abs(e.deltaY);

      /* Si el scroll es predominantemente horizontal: tomamos control */
      if (absX >= absY * 0.4 && absX >= 2) {
        /* preventDefault SIEMPRE que sea horizontal dentro del slider.
           Esto bloquea el gesto de historial del navegador. */
        e.preventDefault();
        e.stopPropagation();

        if (cooling) return;

        accumulated += e.deltaX;

        if (Math.abs(accumulated) < THRESHOLD) return;

        var direction = accumulated > 0 ? 'next' : 'prev';
        accumulated = 0;
        cooling = true;

        if (direction === 'next') { swiper.slideNext(350); }
        else                      { swiper.slidePrev(350); }

        clearTimeout(coolTimer);
        coolTimer = setTimeout(function () { cooling = false; }, COOLDOWN_MS);
      }
    }, { passive: false, capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
